import { RESERVED_OFFER_ACTIONS } from 'utils/actions/reservedOffer'

const defaultState = {
  reservedOfferDetailsAreLoading: false,
  reservedOfferDetails: null,
  reservedOfferDetailsError: null,
}

const {
  RESERVED_OFFER_DETAILS_FAILURE,
  RESERVED_OFFER_DETAILS_REQUEST,
  RESERVED_OFFER_DETAILS_RESET,
  RESERVED_OFFER_DETAILS_SUCCESS,
} = RESERVED_OFFER_ACTIONS

const reservedOfferReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case RESERVED_OFFER_DETAILS_REQUEST:
      return {
        ...state,
        reservedOfferDetails: null,
        reservedOfferDetailsAreLoading: true,
        reservedOfferDetailsError: null,
      }

    case RESERVED_OFFER_DETAILS_SUCCESS: {
      const {
        waterfallInfo: { currentMatch, datMarketLaneId, nextKickoff, totalMatches },
      } = action.payload
      return {
        ...state,
        reservedOfferDetails: {
          currentMatch,
          totalMatches,
          datMarketLaneId,
          nextKickoff,
        },
        reservedOfferDetailsError: null,
        reservedOfferDetailsAreLoading: false,
      }
    }

    case RESERVED_OFFER_DETAILS_FAILURE: {
      const {
        payload: { error: reservedOfferDetailsError },
      } = action
      return {
        ...state,
        reservedOfferDetailsError,
      }
    }

    case RESERVED_OFFER_DETAILS_RESET:
      return {
        ...state,
        ...defaultState,
      }

    default:
      return state
  }
}

export default reservedOfferReducer
